'use client'

import { EnvelopeClosedIcon } from '@radix-ui/react-icons'
import { useMemo } from 'react'
import { Button } from '@/components/button'
import { Motion } from '@/components/motion'
import { T } from '@/components/t'

export const ContactLandingPage = ({ hideTitle }: { hideTitle?: boolean }) => {
    const supportEmail = useMemo(
        () =>
            ({
                externalUrl: 'mailto:support@neotaste.app',
            }) as const,
        []
    )

    return (
        <section className="flex w-full flex-col items-center py-7 md:py-12 px-4 mb-40 max-w-[700px]">
            {!hideTitle && (
                <Motion baseDelay={0.25} y={55}>
                    <h1 className="text-[36px] md:text-[40px] lg:text-[44px] xl:text-[48px] font-bold text-center mb-8">
                        <T span t={'contact.hero.title'} />
                    </h1>
                </Motion>
            )}

            <Motion baseDelay={0.45} y={70} className="flex flex-col items-center">
                <T
                    p
                    t="contact.hero.description"
                    className="font-normal  mb-6 text-black/70 text-center text-[14px] md:text-[16px]"
                />

                <Button
                    shape="pill"
                    width="max-content"
                    height="46px"
                    styleType="primary"
                    href={supportEmail}
                    target="_blank"
                >
                    <EnvelopeClosedIcon className="w-5 h-5 mr-1" />
                    support@neotaste.app
                </Button>
            </Motion>
        </section>
    )
}
